<template>
	<div class="IdentityUserPassword"  >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-shenfenyanzheng- Icon" ></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 身份&amp;安全 / 账号密码</span>
		</div>
		<div class="content_Box box-shadow m-t-15 p-l-10 p-r-10" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="headerBox">
				账号登录密码
			</div>
			<div class="">
				<div class="row-info clear">
					<div class="fl title-key">登录账号</div>
					<div class="fl list-cont">{{userInfo.username}}</div>
				</div>
				<div class="row-info clear">
					<div class="fl title-key"><i class="zb zb-asterisk" ></i>现有登录密码</div>
					<div class="fl list-cont"><el-input placeholder="请输入" v-model.trim="original_pwd" show-password ></el-input></div>
				</div>
				<div class="row-info clear">
					<div class="fl title-key"><i class="zb zb-asterisk" ></i>新设密码</div>
					<div class="fl list-cont">
						<el-input placeholder="请输入" v-model.trim="new_pwd" show-password></el-input>
					</div>
					<b class="hintSelect">（需要字母和数字密码8~16位）</b>
				</div>
				<div class="row-info clear">
					<div class="fl title-key"><i class="zb zb-asterisk" ></i>确认新密码</div>
					<div class="fl list-cont"><el-input placeholder="请输入" v-model.trim="confirm_pwd" show-password></el-input></div>
				</div>
				<div class="clear"></div>
			</div>
			<div class="submitBox">
				<span class="btnOK" @click="savePassword">保 存</span>
			</div>
			
			<div class="headerBox">
				支付密码
			</div>
			<div class="">
				<p class="passwordHint">支付密码用于转账和订单支付，请设置与登录密码不同</p>
				<div class="row-info clear">
					<div class="fl title-key">现有支付密码</div>
					<div class="fl list-cont">
						<el-input placeholder="请输入" v-model.trim="paymentPassword" show-password maxlength="6"></el-input>
					</div>
					<b class="hintSelect">（6位数字）</b>
				</div>
				<div class="row-info clear">
					<div class="fl title-key"><i class="zb zb-asterisk" ></i>新支付密码</div>
					<div class="fl list-cont">
						<el-input placeholder="请输入" v-model.trim="paymentFirstPassword" show-password maxlength="6" ></el-input>
				</div>
				</div>
				<div class="row-info clear">
					<div class="fl title-key"><i class="zb zb-asterisk" ></i>再次确认新密码</div>
					<div class="fl list-cont">
						<el-input placeholder="请输入" v-model.trim="paymentSecondPassword" show-password maxlength="6" ></el-input>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			<div class="submitBox">
				<span class="btnOK" @click="paymentBtn">保 存</span>
			</div>
			
			
		</div>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'IdentityUserPassword',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
				original_pwd:'', //原始密码
				new_pwd:'',	//新密码
				confirm_pwd:'',	//新密码
				paymentPassword:'', //现有支付密码
				paymentFirstPassword:'', //现有支付密码
				paymentSecondPassword:'', //现有支付密码
				
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //判断是否登录
					window.location = 'login.html';
					return;
				}
			},
			// 登录密码
			savePassword(){
				if(this.original_pwd == ''){
					// this.$message.error('请输入现有登录密码！');
					this.$alert('<strong>请输入现有登录密码!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				if(this.new_pwd == '' || this.confirm_pwd == ''){
					// this.$message.error('请输入新密码！');
					this.$alert('<strong>请输入新密码!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				let regPwd = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
				if (!regPwd.test(this.new_pwd) || !regPwd.test(this.confirm_pwd)) {
					// this.$message.error('请按要求输入密码！');
					this.$alert('<strong>请按要求输入密码!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				if (this.new_pwd !== this.confirm_pwd) {
					// this.$message.error('两次密码输入不一致！');
					this.$alert('<strong>两次密码输入不一致!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				let fn = new FormData();
				fn.append('original_pwd', this.original_pwd); //原始密码
				fn.append('new_pwd', this.new_pwd); //密码1
				fn.append('confirm_pwd', this.confirm_pwd); //密码2
				this.$http.post(this.url + '/zhongfy/company/updatePwd',fn).then((res) => {
					if ( res.data.code == '200') {
						// this.$alert('<strong style="color:#D0121B;">密码修改成功请重新登录！</strong>', '提示', {
						//     dangerouslyUseHTMLString: true
						// });
						this.$alert('<strong style="color:#D0121B;">密码修改成功请重新登录！</strong>', '提示', {
							dangerouslyUseHTMLString: true,
							confirmButtonText: '确定',
						    callback: action => {
						        sessionStorage.clear();
						        window.location.href = 'login.html';    
						    }
						});
						return;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
						this.$alert('<strong>'+res.data.msg+'</strong>', '提示', {
						    dangerouslyUseHTMLString: true
						});
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			// 支付密码
			paymentBtn(){
				if(this.paymentPassword == ''){
					this.$alert('<strong>请输入现有支付密码!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				if(this.paymentFirstPassword == '' || this.paymentSecondPassword == ''){
					this.$alert('<strong>请输入新密码!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				let regPwd = /^\d{6}$/;
				if (!regPwd.test(this.paymentFirstPassword) || !regPwd.test(this.paymentSecondPassword)) {
					this.$alert('<strong>请按要求输入密码!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				if (this.paymentFirstPassword !== this.paymentSecondPassword) {
					this.$alert('<strong>两次密码输入不一致!</strong>', '提示', {
					    dangerouslyUseHTMLString: true
					});
					return;
				}
				let fn = new FormData();
				fn.append('original_pwd', this.paymentPassword); //原始密码
				fn.append('new_pwd', this.paymentFirstPassword); //密码1
				fn.append('confirm_pwd', this.paymentSecondPassword); //密码2
				this.$http.post(this.url + '/zhongfy/company/updatePayPwd',fn).then((res) => {
					if ( res.data.code == '200') {
						this.paymentPassword = '';
						this.paymentFirstPassword ='';
						this.paymentSecondPassword ='';
						this.$alert('<strong>支付密码修改成功！</strong>', '提示', {
						    dangerouslyUseHTMLString: true
						});
						return;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$alert('<strong>'+res.data.msg+'</strong>', '提示', {
						    dangerouslyUseHTMLString: true
						});
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			}
			

		}
	}
</script>

<style scoped>
	.IdentityUserPassword {}
	.zb-asterisk{font-size: 10px;color: var(--theme-red);}
	.headerBox {height: 35px;line-height: 35px;font-size: 14px;padding-left: 10px;border-bottom: 1px solid #E8E8E8;font-weight: 700;color:#333333;}
	.hintSelect{color: #999999;font-size: 12px;line-height: 30px;}
	.submitBox{margin-top: 30px;height: 50px;padding-left: 105px;}
	.passwordHint{width: 300px;height: 28px;line-height: 28px;border:1px solid var(--theme-red) !important;border-radius: 2px;font-size: 12px;padding: 0 10px;color: var(--theme-red) !important;background-color: #ffff80;margin : 10px 0;}
	.row-info{padding: 5px 0;}
	.title-key{width:94px;}
	
</style>



// WEBPACK FOOTER //
// src/components/IdentityUserPassword.vue